<div class="product-result__card">
	<a class="product-result__link" :href="url">
		<div v-if="primaryImageUrl" class="product-result__img">
			<img class="sr-product-card__image" :src="primaryImageUrl" :alt="displayName">
		</div>
		<div class="product-result__body">
			<div v-if="stockNumber" class="product-result__stock-number"><span v-html="highlightResults.stockNumber.value">{{highlightResults.stockNumber.value}}</span></div>
			<div v-if="displayName" class="product-result__display-name"><span v-html="highlightResults.displayName.value">{{highlightResults.displayName.value}}</span></div>
			<div v-if="additionalDisplayName" class="product-result__additional-display-name"><span v-html="highlightResults.additionalDisplayName.value">{{highlightResults.additionalDisplayName.value}}</span></div>
		</div>
	</a>
</div>
